/* eslint-disable no-console */

// pour gérer l'update de service worker : https://medium.com/@dougallrich/give-users-control-over-app-updates-in-vue-cli-3-pwas-20453aedc1f2

import {register} from 'register-service-worker';

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    registered(registration: ServiceWorkerRegistration) {

      // Routinely check for app updates by testing for a new service worker.
      setInterval(() => {
        registration.update();
      }, 1000 * 60 * 60 * 12); // toutes les deux heures
    },
    updated(registration: RegistrationOptions) {
      // Add a custom event and dispatch it.
      document.dispatchEvent(new CustomEvent('swUpdated', {detail: registration}));
    },
  });
}
